export const pages = {
  auth: {
    signIn: '/entrar',
    signUp: '/cadastro',
    forgotPassword: '/recuperar-senha',
  },
  privacyPolicies: '/politica-de-privacidade',
  terms: '/termos-e-condicao-de-uso',
  home: '/',
  search: '/buscar',
  drugInteraction: '/interacoes-medicamentosas',
  user: { profile: '/perfil' },
  payment: '/pagamento',
  checkout: '/checkout',
  notes: {
    list: '/anotacoes/:id?',
    create: '/anotacoes/:id?/nova',
    editPrescription: '/anotacoes/:id?/arquivos/:fileId/editar',
    file: '/anotacoes/:id?/arquivos/:fileId',
  },
  suggestTopic: '/sugerir-tema',
  favorites: '/favoritos',
  medicines: {
    list: `/medicamentos`,
    details: (id: string) => `/medicamentos/${id}`,
  },
  theme: '/temas/:themeId',
  topic: '/temas/:themeId/topicos/:topicId',
  calculators: {
    list: '/calculadoras',
    vasoactiveDrugs: '/calculadoras/drogas_vasopressoras',
    vasodilatorDrugs: '/calculadoras/drogas_vasodilatadoras',
    iotDrugs: '/calculadoras/drogas_iot',
    continuedSedation: '/calculadoras/drogas_sedacao',
    sodiumDisorder: '/calculadoras/correcao_sodio',
    burntHydration: '/calculadoras/hidratacao_queimado',

    glomerularFiltrationRate: '/calculadoras/clearance',
    conversationMlDrops: '/calculadoras/conversor_gota',
    antiEpilepticDrugs: '/calculadoras/anti_epileticos',
    corticosteroidConverter: '/calculadoras/conversor_corticoide',
    opioidConverter: '/calculadoras/conversor_opioide',
    renalFunctionDoseCorrection: '/calculadoras/correcao_dose',

    pediatricHydration: '/calculadoras/hidratacao_pediatria',
    pediatricAntibioticDosage: '/calculadoras/dose_antibiotico',
    pediatricSymptomaticDose: '/calculadoras/dose_sistomatico',
    pediatricEmergencyDose: '/calculadoras/dose_emergencia',
  },
};
